/* ============================================================
   DAYATECH — Technology Page interactions
   · scroll reveal (复刻现站 .reveal 触发机制)
   · count-up 数字 (data-countup)
   · 环形能效计填充 (data-ring)
   · 双柱亮度填充 (data-bar)
   守现站约定: ease-out 缓动 · prefers-reduced-motion 全禁用 (静态终值)
   纯 vanilla · 无第三方库
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Scroll reveal (技术页本地·与现站 app.js 同语义) ---------- */
  var reveals = [].slice.call(document.querySelectorAll('.reveal'));
  if ('IntersectionObserver' in window && reveals.length) {
    var revObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          revObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { revObs.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- 2. count-up + ring + bar — 滚动进入时触发一次 ---------- */
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  // 数字 count-up
  function runCountUp(el) {
    var target = parseFloat(el.getAttribute('data-countup'));
    var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    if (isNaN(target)) return;
    if (reduce) { el.textContent = prefix + target.toFixed(decimals) + suffix; return; }
    var dur = 1400, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var val = target * easeOutCubic(p);
      el.textContent = prefix + val.toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toFixed(decimals) + suffix;
    }
    requestAnimationFrame(step);
  }

  // 环形能效计填充 (data-ring = 百分比 0-100·决定弧长)
  function runRing(el) {
    var fill = el.querySelector('.metric__ring-fill');
    if (!fill) return;
    var r = parseFloat(fill.getAttribute('r'));
    var circ = 2 * Math.PI * r;
    fill.style.strokeDasharray = circ;
    var pct = parseFloat(el.getAttribute('data-ring')) || 0;
    var offset = circ * (1 - pct / 100);
    if (reduce) { fill.style.strokeDashoffset = offset; return; }
    fill.style.strokeDashoffset = circ;          // 空起点
    requestAnimationFrame(function () {          // 下一帧触发 transition
      fill.style.strokeDashoffset = offset;
    });
  }

  // 双柱亮度填充 (data-bar 容器内 .metric__bar 各带 data-h = 目标高度%)
  function runBars(el) {
    var bars = [].slice.call(el.querySelectorAll('.metric__bar'));
    bars.forEach(function (b) {
      var h = b.getAttribute('data-h') || '0';
      if (reduce) { b.style.height = h + '%'; return; }
      b.style.height = '0%';
      requestAnimationFrame(function () { b.style.height = h + '%'; });
    });
  }

  function activate(el) {
    if (el.hasAttribute('data-countup')) runCountUp(el);
    if (el.hasAttribute('data-ring')) runRing(el);
    if (el.hasAttribute('data-bar')) runBars(el);
  }

  var animTargets = [].slice.call(
    document.querySelectorAll('[data-countup], [data-ring], [data-bar]')
  );
  if ('IntersectionObserver' in window && animTargets.length) {
    var animObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          activate(e.target);
          animObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.35 });
    animTargets.forEach(function (el) { animObs.observe(el); });
  } else {
    animTargets.forEach(activate);
  }

})();
